import React from "react";
import ReviewManagementSummary from "../../features/reviewmanagementsummary";
import { ClientReviewManagementFilterSubHeader } from "../../layouts/ClientReviewManagementLayout";

const ReviewManagementSummaryPage = () => 
    <React.Fragment>
        <ClientReviewManagementFilterSubHeader includeCompletedSelect={false}/>
             <section className="px-4 my-3 h-100">
                <ReviewManagementSummary />
             </section>
    </React.Fragment>

export default ReviewManagementSummaryPage;